import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import TimeModal from '../../common/TimeModal'

import * as Strings from './strings'
import * as configActions from '../../actions/Config'
import * as bookingSystemTimesActions from '../../actions/BookingSystemTimes'

class EditBookableTimeModal extends Component {
  state = {
    startTimeInput: '',
    endTimeInput: '',
    errorStartTime: '',
    errorEndTime: '',
    errorMessage: ''
  }

  componentWillReceiveProps(nextProps) {
    const { config, bookingSystemTimes } = this.props

    if (
      nextProps.config.editBookingSystemTimeModal.show &&
      !config.editBookingSystemTimeModal.show
    ) {
      this.setState({
        startTimeInput: nextProps.bookingSystemTimes.selected.time.start,
        endTimeInput: nextProps.bookingSystemTimes.selected.time.end,
        errorEndTime: '',
        errorStartTime: '',
        errorMessage: ''
      })
    }

    if (
      !nextProps.bookingSystemTimes.isUpdating &&
      nextProps.bookingSystemTimes.errorUpdating === null &&
      bookingSystemTimes.isUpdating
    ) {
      this.props.hideEditBookingSystemTimeModal()
      this.props.showSnackbar(Strings.default.TIME_UPDATED)
    } else if (
      !nextProps.bookingSystemTimes.isUpdating &&
      nextProps.bookingSystemTimes.errorUpdating !== null &&
      bookingSystemTimes.isUpdating
    ) {
      this.setState({ errorMessage: Strings.default.INTERNAL_ERROR })
    }
  }

  update() {
    const { user, bookingSystemTimes } = this.props
    const { startTimeInput, endTimeInput } = this.state

    this.setState({ errorMessage: '' })

    if (startTimeInput === '') {
      this.setState({ errorStartTime: Strings.default.MANDATORY_FIELD })
    }

    if (endTimeInput === '') {
      this.setState({ errorEndTime: Strings.default.MANDATORY_FIELD })
    }

    if (startTimeInput !== '' && endTimeInput !== '') {
      const postData = {
        start: startTimeInput,
        end: endTimeInput
      }

      this.props.tryUpdateBookingSystemTime(
        user.token,
        bookingSystemTimes.selected.systemId,
        bookingSystemTimes.selected.time.id,
        postData
      )
    }
  }

  render() {
    const { config, bookingSystemTimes } = this.props
    const {
      startTimeInput,
      endTimeInput,
      errorStartTime,
      errorEndTime,
      errorMessage
    } = this.state

    return (
      <TimeModal
        show={config.editBookingSystemTimeModal.show}
        hide={() => this.props.hideEditBookingSystemTimeModal()}
        startTimeInput={startTimeInput}
        onChangeStartTimeInput={text =>
          this.setState({
            startTimeInput: text,
            errorStartTime: '',
            errorMessage: ''
          })
        }
        errorStartTime={errorStartTime}
        endTimeInput={endTimeInput}
        onChangeEndTimeInput={text => {
          this.setState({
            endTimeInput: text,
            errorEndTime: '',
            errorMessage: ''
          })
        }}
        errorEndTime={errorEndTime}
        header={Strings.default.EDIT_TIME}
        information={Strings.default.EDIT_TIME_INFORMATION}
        onDone={() => this.update()}
        loading={bookingSystemTimes.isUpdating}
        errorMessage={errorMessage}
      />
    )
  }
}

function mapStateToProps({ config, data, user, bookingSystemTimes }) {
  return { config, data, user, bookingSystemTimes }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    { ...configActions, ...bookingSystemTimesActions },
    dispatch
  )
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EditBookableTimeModal)



// WEBPACK FOOTER //
// ./src/components/containers/EditBookableTimeModal/index.js